import { createSlice } from '@reduxjs/toolkit';
import { FieldsStore } from './store';
export const slice = createSlice({
    name: '@@FIELDS',
    initialState: FieldsStore.empty(),
    reducers: {
        load: (state)=>FieldsStore.load()(state),
        putAll: (state, { payload: fields })=>FieldsStore.putAll(fields)(state),
        add: (state, { payload: field })=>FieldsStore.add(field)(state),
        remove: (state, { payload: fieldId })=>FieldsStore.remove(fieldId)(state),
        refresh: (state, { payload: args })=>FieldsStore.refresh(...args)(state)
    }
});
